import { render, staticRenderFns } from "./TestSpeakingChild.vue?vue&type=template&id=2ea833d4&scoped=true"
import script from "./TestSpeakingChild.vue?vue&type=script&lang=js"
export * from "./TestSpeakingChild.vue?vue&type=script&lang=js"
import style0 from "./TestSpeakingChild.vue?vue&type=style&index=0&id=2ea833d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea833d4",
  null
  
)

export default component.exports